import React from "react";
import ReactDOM from "react-dom/client";
import "./global.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import StripeProvider from "./components/AccountComponents/StripeProvider";
import { BrowserRouter as Router } from "react-router-dom";
import { Toaster } from "react-hot-toast";

const isAmityTransientError = (reason) => {
  const msg = String(reason?.message || reason || "");
  const stack = String(reason?.stack || "");
  const url = String(reason?.config?.url || reason?.request?.responseURL || "");
  return (
    msg.startsWith("<html>") ||
    msg.includes("502") ||
    msg.includes("Bad Gateway") ||
    stack.includes("getMessageMarkers") ||
    stack.includes("amity") ||
    stack.includes("onboarding") ||
    url.includes("amity.co")
  );
};

window.addEventListener(
  "unhandledrejection",
  (event) => {
    if (isAmityTransientError(event.reason)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      console.warn(
        "[Amity] Temporary API error suppressed (502 Bad Gateway). Chat will sync automatically when the service recovers."
      );
    }
  },
  true
);

window.addEventListener(
  "error",
  (event) => {
    if (isAmityTransientError(event.error)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  },
  true
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router>
      <App />
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 4500,
          style: { fontFamily: "Inter, sans-serif" },
        }}
      />
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
